import styled from '@emotion/styled';
import { Col, Row } from 'antd';

export const MainContainer = styled.div`
  width: 98%;
  margin: 15px;
`;

export const InventoryContainer = styled.div`
  width: 100%;
`;

export const BodyContainer = styled.div`
  margin-top: 40px;
  padding: 20px;
  background-color: white;
  border: 1px solid #e8e8e8;
`;
